import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApolloClient } from '@apollo/react-hooks';
import { DeveloperLoginView } from './view';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useAppDeveloperLoginMutation } from 'types/generated';

const useQuery = () => {
    const location = useLocation();
    return new URLSearchParams(location.search);
};

export function DeveloperLogin() {
    const navigate = useNavigate();
    const client = useApolloClient();
    const query = useQuery();
    const validated = query.get('validated') ? query.get('validated') === 'true' : undefined;
    const message = query.get('message') ? query.get('message') : undefined;
    const [showMessage, setShowMessage] = useState(Boolean(validated !== undefined && message));

    const [login, { loading, error }] = useAppDeveloperLoginMutation({
        onCompleted({ appAccountLogin }) {
            localStorage.setItem('user', JSON.stringify(appAccountLogin.node));
            client.writeData({ data: { isLoggedIn: true, user: appAccountLogin.node } });
            navigate('/extranet');
        },
    });

    const onSubmit = (values, form, callback) => {
        login({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    return (
        <>
            {showMessage && (
                <Snackbar
                    open={showMessage}
                    onClose={() => setShowMessage(false)}
                    autoHideDuration={12000}
                >
                    <Alert severity={validated ? 'success' : 'error'}>{message}</Alert>
                </Snackbar>
            )}
            <DeveloperLoginView onSubmit={onSubmit} error={error} loading={loading} />
        </>
    );
}
